import {
    SET_VIEW_LIST, SET_VIEW_MAP,
    LIST_VIEW, MAP_VIEW
} from '../actions/ViewAction';

const defaultState = {
    placesView: MAP_VIEW,
    userActed: false,
};

const view = (state = defaultState, action) => {
    switch (action.type)
    {
        case SET_VIEW_LIST:
            return {
                placesView: LIST_VIEW,
                userActed: action.userActed,
            };
        case SET_VIEW_MAP:
            return {
                placesView: MAP_VIEW,
                userActed: action.userActed,
            };
        default:
            return state;
    }
};

export default view;



// WEBPACK FOOTER //
// ./src/reducers/ViewReducer.js